import { Routes, Route, Navigate } from "react-router-dom";
import { SettingsLayout } from "../components/settings/SettingsLayout";
import { ProfileSettings } from "../components/settings/ProfileSettings";
import { PreferencesSettings } from "../components/settings/PreferencesSettings";
import { IntegrationsSettings } from "../components/settings/IntegrationsSettings";
import { BillingSettings } from "../components/settings/BillingSettings";
import React from "react";

export default function Settings() {
  return (
    <Routes>
      <Route element={<SettingsLayout />}>
        <Route index element={<Navigate to="profile" replace />} />
        <Route path="profile" element={<ProfileSettings />} />
        <Route path="preferences" element={<PreferencesSettings />} />
        <Route path="billing" element={<BillingSettings />} />
        <Route path="integrations" element={<IntegrationsSettings />} />
      </Route>
    </Routes>
  );
}